import * as React from 'react';

const FrenchIcon = ({ size = 36 }) => {
    return (
        <svg width={size} height={size} viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <clipPath id='circle-fr'>
                <circle cx={15} cy={11} r={10} />
            </clipPath>
            <g clipPath='url(#circle-fr)'>
                <rect x={5} y={1} width={6.67} height={20} fill='#002395' />
                <rect x={11.67} y={1} width={6.67} height={20} fill='#FFFFFF' />
                <rect x={18.34} y={1} width={6.67} height={20} fill='#ED2939' />
            </g>
            <circle cx={15} cy={11} r={10} stroke='#e0e0e0' strokeWidth={0.5} fill='none' />
        </svg>
    );
};

export default FrenchIcon;
